

import { io } from "socket.io-client";

//const socket = io("http://localhost:5000", {
 const socket = io("https://preprod.solutionsexpressqc.ca", {
  path: "/socket.io",
  transports: ["websocket"],
  autoConnect: false, //  IMPORTANT
});

export default socket;
